import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useFormContext } from '@afosto/app-components-react/Form';
import CalculationEditItemForm from '../../CalculationEditItemForm';
import CalculationInvoiceItem from '../CalculationInvoiceItem';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import StackItemList from '@afosto/app-components-react/StackItemList';
import translations from './translations';

const CalculationItemFormSection = ({ isFetchingProjection }) => {
  const intl = useIntl();
  const formContext = useFormContext();
  const [highlightedItem, setHighlightedItem] = useState(null);
  const { watch, setValue } = formContext || {};
  const itemsValue = watch('items');

  const renderItem = item => (
    <CalculationInvoiceItem
      key={item.reference}
      item={item}
      onClick={clickedItem => setHighlightedItem(clickedItem)}
    />
  );

  /**
   * Handle editing an existing item.
   * @returns {Promise}
   */
  const handleEditItem = async ({ reference, quantity }) => {
    try {
      const otherItems = [...itemsValue].filter(item => item.reference !== reference);
      const currentItem = [...itemsValue].find(item => item.reference === reference);

      if (currentItem) {
        setValue('items', [
          ...otherItems,
          {
            ...currentItem,
            quantity: parseInt(quantity, 10),
          },
        ]);
        setHighlightedItem(null);
      }
    } catch (err) {
      // Do something with error.
    }
  };

  return (
    <>
      <StackItemList
        items={itemsValue}
        renderItem={renderItem}
        isLoading={isFetchingProjection}
        allowNegativeQuantity
      />
      <FormDrawer
        title={intl.formatMessage(translations.itemDrawer.title)}
        isOpen={!!highlightedItem}
        onClose={() => setHighlightedItem(null)}
        drawerWidth="420px"
      >
        <CalculationEditItemForm
          onCancel={() => setHighlightedItem(null)}
          onSubmit={handleEditItem}
          item={highlightedItem}
        />
      </FormDrawer>
    </>
  );
};

CalculationItemFormSection.propTypes = {
  isFetchingProjection: PropTypes.bool,
};

CalculationItemFormSection.defaultProps = {
  isFetchingProjection: true,
};

export default CalculationItemFormSection;
